document.addEventListener("DOMContentLoaded", function () {

    const sectionCache = new WeakMap();
    const sectionLoading = new WeakMap();

    document.addEventListener('click', function (event) {

        const filterBtn = event.target.closest('.js-filter-btn');
        if (filterBtn) {
            event.preventDefault();
            const form = filterBtn.closest('.js-filter-form');
            if (form) {
                form.querySelector('[name="category"]').value = filterBtn.dataset.category ?? '';
            }
            const section = filterBtn.closest('.js-archive');
            if (section) archiveFilter(section, 1);
        }

        const paginateBtn = event.target.closest('.paginate');
        if (paginateBtn) {
            event.preventDefault();
            const section = paginateBtn.closest('.js-archive');
            if (section) archiveFilter(section, paginateBtn.dataset.pagination);
        }

    });

    function archiveFilter(section, pagination) {
        if (sectionLoading.get(section)) return;

        const form = section.querySelector('.js-filter-form');
        const listContainer       = section.querySelector(section.dataset.list);
        const paginationContainer = section.querySelector(section.dataset.pagination);
        const category            = form.querySelector('[name="category"]').value;
        const cacheKey            = `${category}|${pagination}`;

        if (!sectionCache.has(section)) sectionCache.set(section, new Map());
        const cache = sectionCache.get(section);

        if (cache.has(cacheKey)) {
            const data = cache.get(cacheKey);
            if (listContainer)       listContainer.innerHTML       = data.items;
            if (paginationContainer) paginationContainer.innerHTML = data.pagination;
            updateFilterState(section, category);
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        sectionLoading.set(section, true);
        section.classList.add('is-loading');

        let formData = new FormData(form);
        formData.append('action', section.dataset.action);
        formData.append('page', pagination);

        fetch(urls.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(formData),
        }).then(function (response) {
            return response.json();
        }).then(function (response) {
            if (!response.success) {
                console.error('Archive filter error');
                return;
            }

            cache.set(cacheKey, response.data);
            if (listContainer)       listContainer.innerHTML       = response.data.items;
            if (paginationContainer) paginationContainer.innerHTML = response.data.pagination;

            updateFilterState(section, category);
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }).finally(function () {
            sectionLoading.set(section, false);
            section.classList.remove('is-loading');
        });
    }

    function updateFilterState(section, activeCategory) {
        section.querySelectorAll('.js-filter-btn').forEach(function (btn) {
            btn.classList.toggle('filter__btn--active', (btn.dataset.category ?? '') === activeCategory);
        });
    }

});
